import { Trans, useTranslation } from 'react-i18next';

import { Link } from '@mui/material';
import { Ribbon } from 'common/components';
import { type BackendErrorAlertData } from 'modules/alerts/state';
import { isApiErrorMessage } from 'modules/api/utils';

import { ErrorCodeContainer } from './components';

const SUPPORT_TEAM_URL = window._env_.VITE_APP_INTERCOM_URL;

type Props = Pick<BackendErrorAlertData, 'message'> & { onClose(): void };

export const ApiErrorAlert = ({ message, onClose }: Props) => {
  const { t } = useTranslation();

  return (
    <Ribbon onClose={onClose}>
      <Trans
        t={t}
        i18nKey="genericApiError"
        components={{
          HelpCentre: (
            <Link underline="always" component="a" href={SUPPORT_TEAM_URL} target="_blank" color="common.white" />
          ),
        }}
      />
      {isApiErrorMessage(message) && <ErrorCodeContainer {...message} />}
    </Ribbon>
  );
};
